import React, { useEffect, useRef, useState } from "react";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  ContentState,
} from "draft-js";
import Editor from "@draft-js-plugins/editor";
import createInlineToolbarPlugin from "@draft-js-plugins/inline-toolbar";
import draftToHtml from "draftjs-to-html";
import { stateFromHTML } from "draft-js-import-html";
import createToolbarPlugin from "@draft-js-plugins/static-toolbar";
import * as commondata from "../../Common";
import "draft-js/dist/Draft.css";

const DraftjsInline = ({
  editorState: value,
  onChange: pOnchange,
  statictool,
  onBlur=() => {},
}) => {
  const [{ plugins, Toolbar, InlineToolbar }] = useState(() => {
    const toolbarPlugin = createInlineToolbarPlugin();
    const staticToolbarPlugin = createToolbarPlugin();
    return {
      plugins: [toolbarPlugin, staticToolbarPlugin],
      Toolbar: staticToolbarPlugin.Toolbar,
      InlineToolbar: toolbarPlugin.InlineToolbar,
    };
  });

  // Function to safely initialize the editor state
  const initializeEditorState = (val) => {
    if (!val || val.trim() === "") return EditorState.createEmpty(); // Handle empty value

    try {
      const content = convertFromRaw(JSON.parse(val)); // JSON format
      return EditorState.createWithContent(content);
    } catch (error) {
      try {
        const contentState = stateFromHTML(val); // Handle raw HTML
        return EditorState.createWithContent(contentState);
      } catch (error) {
        return EditorState.createEmpty(); // Fallback if invalid
      }
    }
  };

  const [editorState, setEditorState] = useState(() =>
    initializeEditorState(value)
  );

 useEffect(() => {
  if (value !== undefined) {
    const currentContent = editorState.getCurrentContent()
    const currentHtml = draftToHtml(convertToRaw(currentContent))

    if (value !== currentHtml && !editorState.getSelection().getHasFocus()) {
      const newState = initializeEditorState(value)
      setEditorState(newState)
    }
  }
}, [value])


  const handleChange = (newEditorState) => {
    const contentState = newEditorState.getCurrentContent();
    const rawContent = convertToRaw(contentState);
    const htmlContent = draftToHtml(rawContent);

    // Ensure blank editor sends empty string
    const isEmpty = !contentState.hasText();
    pOnchange(isEmpty ? "" : htmlContent);

    setEditorState(newEditorState);
  };

  const editor = useRef(null);

  const focus = () => {
    editor.current?.focus();
  };

  return (
    <div
      className="editor-container"
      onClick={focus}
      style={{
        border: "2px solid #ccc",
        borderRadius: "5px",
        padding: "10px",
        minHeight: "100px",
        backgroundColor: "white",
      }}
    >
      <Editor
        editorState={editorState}
        onChange={handleChange}
        plugins={plugins}
        ref={(element) => {
          editor.current = element;
        }}
        onBlur={onBlur}
      />

      {statictool ? (
        <Toolbar>
          {(externalProps) => (
            <div>
              <BoldButton {...externalProps} />
              <ItalicButton {...externalProps} />
              <UnderlineButton {...externalProps} />
              <UnorderedListButton {...externalProps} />
              <OrderedListButton {...externalProps} />
            </div>
          )}
        </Toolbar>
      ) : (
        <InlineToolbar>
          {(externalProps) => (
            <div>
              {/* <BoldButton {...externalProps} /> */}
              {/* <ItalicButton {...externalProps} />
              <UnderlineButton {...externalProps} />
              <UnorderedListButton {...externalProps} />
              <OrderedListButton {...externalProps} /> */}
            </div>
          )}
        </InlineToolbar>
      )}
    </div>
  );
};

export default React.memo(DraftjsInline);
